import type { ReactNode } from 'react'

export const GuidedTourInteractionType = 'interaction-profile-guided-tour'
export const AgreedPlacePhotoInteractionType = 'interaction-agreed-place-photo'
export const ValidateMobileNumberInteractionType = 'interaction-validate-mobile-number'

export type InteractionType =
  | typeof GuidedTourInteractionType
  | typeof AgreedPlacePhotoInteractionType
  | typeof ValidateMobileNumberInteractionType

export type Interaction = {
  component: ReactNode
  shouldExecute: () => Promise<boolean>
  type: InteractionType
}

export type InteractionConfig = {
  interactions: Interaction[]
}
